import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "hasContentBefore"];
import { useCombinedThemeMode } from "@smartsheet/sds-theme-internal";
import React from "react";
import { selectBasicFontTheme } from "../selectV2Theme";
import { SelectPlaceholderStyled } from "./SelectPlaceholderStyled";
export var SelectPlaceholder = function SelectPlaceholder(_ref) {
  var children = _ref.children,
    hasContentBefore = _ref.hasContentBefore,
    rest = _objectWithoutProperties(_ref, _excluded);
  var themeMode = useCombinedThemeMode();
  return /*#__PURE__*/React.createElement(SelectPlaceholderStyled, _extends({
    themeMode: themeMode
  }, selectBasicFontTheme.variant[themeMode], {
    lineClamp: 1,
    "aria-hidden": true,
    hasContentBefore: hasContentBefore
  }, rest), children);
};
//# sourceMappingURL=SelectPlaceholder.js.map